const returnKeys = (keyCode, isShift, shiftKeyCode) => ({ keyCode, isShift, shiftKeyCode });

const shiftKeyCode = 42;

const keyHelper = {
  keys: [
    { key_name: "`", keycode: "41", shift_key_name: "~" },
    { key_name: "escape", keycode: "1" },
    { key_name: "1", keycode: "2", shift_key_name: "!" },
    { key_name: "2", keycode: "3", shift_key_name: "@" },
    { key_name: "3", keycode: "4", shift_key_name: "#" },
    { key_name: "4", keycode: "5", shift_key_name: "$" },
    { key_name: "5", keycode: "6", shift_key_name: "%" },
    { key_name: "6", keycode: "7", shift_key_name: "^" },
    { key_name: "7", keycode: "8", shift_key_name: "&" },
    { key_name: "8", keycode: "9", shift_key_name: "*" },
    { key_name: "9", keycode: "10", shift_key_name: "(" },
    { key_name: "0", keycode: "11", shift_key_name: ")" },
    { key_name: "-", keycode: "12", shift_key_name: "_" },
    { key_name: "=", keycode: "13", shift_key_name: "+" },
    { key_name: "backspace", keycode: "14" },

    { key_name: "tab", keycode: "15" },
    { key_name: "q", keycode: "16", shift_key_name: "Q" },
    { key_name: "w", keycode: "17", shift_key_name: "W" },
    { key_name: "e", keycode: "18", shift_key_name: "E" },
    { key_name: "r", keycode: "19", shift_key_name: "R" },
    { key_name: "t", keycode: "20", shift_key_name: "T" },
    { key_name: "y", keycode: "21", shift_key_name: "Y" },
    { key_name: "u", keycode: "22", shift_key_name: "U" },
    { key_name: "i", keycode: "23", shift_key_name: "I" },
    { key_name: "o", keycode: "24", shift_key_name: "O" },
    { key_name: "p", keycode: "25", shift_key_name: "P" },
    { key_name: "[", keycode: "26", shift_key_name: "{" },
    { key_name: "]", keycode: "27", shift_key_name: "}" },
    { key_name: "enter", keycode: "28" },
    { key_name: "control", keycode: "29" },

    { key_name: "a", keycode: "30", shift_key_name: "A" },
    { key_name: "s", keycode: "31", shift_key_name: "S" },
    { key_name: "d", keycode: "32", shift_key_name: "D" },
    { key_name: "f", keycode: "33", shift_key_name: "F" },
    { key_name: "g", keycode: "34", shift_key_name: "G" },
    { key_name: "h", keycode: "35", shift_key_name: "H" },
    { key_name: "j", keycode: "36", shift_key_name: "J" },
    { key_name: "k", keycode: "37", shift_key_name: "K" },
    { key_name: "l", keycode: "38", shift_key_name: "L" },
    { key_name: ";", keycode: "39", shift_key_name: ":" },
    { key_name: "'", keycode: "40", shift_key_name: '"' },
    { key_name: "shift", keycode: "42" },
    { key_name: "\\", keycode: "43", shift_key_name: "|" },

    { key_name: "z", keycode: "44", shift_key_name: "Z" },
    { key_name: "x", keycode: "45", shift_key_name: "X" },
    { key_name: "c", keycode: "46", shift_key_name: "C" },
    { key_name: "v", keycode: "47", shift_key_name: "V" },
    { key_name: "b", keycode: "48", shift_key_name: "B" },
    { key_name: "n", keycode: "49", shift_key_name: "N" },
    { key_name: "m", keycode: "50", shift_key_name: "M" },
    { key_name: ",", keycode: "51", shift_key_name: "<" },
    { key_name: ".", keycode: "52", shift_key_name: ">" },
    { key_name: "/", keycode: "53", shift_key_name: "?" },
    { key_name: "alt", keycode: "56" },
    { key_name: " ", keycode: "57" },
    { key_name: "capslock", keycode: "58" },
    { key_name: "f1", keycode: "59" },
    { key_name: "f2", keycode: "60" },
    { key_name: "f3", keycode: "61" },
    { key_name: "f4", keycode: "62" },
    { key_name: "f5", keycode: "63" },
    { key_name: "f6", keycode: "64" },
    { key_name: "f7", keycode: "65" },
    { key_name: "f8", keycode: "66" },
    { key_name: "f9", keycode: "67" },
    { key_name: "f10", keycode: "68" },
    { key_name: "f11", keycode: "87" },
    { key_name: "f12", keycode: "88" },
    { key_name: "home", keycode: "102" },
    { key_name: "arrowup", keycode: "103" },
    { key_name: "pageup", keycode: "104" },
    { key_name: "arrowleft", keycode: "105" },
    { key_name: "arrowright", keycode: "106" },
    { key_name: "end", keycode: "107" },
    { key_name: "arrowdown", keycode: "108" },
    { key_name: "pagedown", keycode: "109" },
    { key_name: "delete", keycode: "111" },
    { key_name: "meta", keycode: "125" },
  ],
  isUpper(str) {
    return str === str.toUpperCase();
  },
  isLower(str) {
    return str === str.toLowerCase();
  },
  isSpecialCharacter(str) {
    return this.keys.some((key) => key.shift_key_name === str);
  },
  getKeyCode(keyName) {
    const returnKey = returnKeys(0, false, shiftKeyCode);

    if (keyName === " ") {
      returnKey.keyCode = 57;
      return returnKey;
    }

    const keyDataFound = this.keys.find((keyData) => {
      if (this.isSpecialCharacter(keyName)) return keyData.shift_key_name === keyName;

      return keyData.key_name === keyName.toLowerCase().trimStart();
    });

    if (keyDataFound) {
      returnKey.keyCode = keyDataFound.keycode;
      returnKey.isShift = this.isSpecialCharacter(keyName) ? true : this.isUpper(keyName);
    } else throw new Error("keycode is not available");

    return returnKey;
  },
};

const isOperatorKey = (key) => ["shift", "control", "alt", "meta"].some((k) => k === key.toLowerCase());

export { keyHelper, isOperatorKey };
